import { PathRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasPathPicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasPathPicker } from "./path-picker";

let loadPathPick = !1;

export function bindPathCanvasPickerContribution(container) {
    loadPathPick || (loadPathPick = !0, container.bind(CanvasPathPicker).toDynamicValue((() => new DefaultCanvasPathPicker(resolveContainerBinding(container, PathRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasPathPicker));
}
//# sourceMappingURL=path-module.js.map
